import { useEffect, useState } from 'react';

const DEFAULT_LOCALE = 'en-US';

export const useDefaultLocale = (locale?: string) => {
    const [browserLocale, setLocale] = useState(locale || DEFAULT_LOCALE);

    useEffect(() => {
        if (
            (locale === undefined || locale === '') &&
            typeof navigator !== 'undefined'
        ) {
            setLocale(navigator.language || DEFAULT_LOCALE);
        }
    }, [locale]);

    return browserLocale;
};
